import { Component } from '@angular/core';
import { ShellComponent } from '@df/ui/common/shell/shell.component';

@Component({
    selector: 'df-image-wrapper',
    standalone: true,
    imports: [ShellComponent],
    template: `
        <shell></shell>
        <ng-content></ng-content>
    `,
    styles: [
        `
            :host ::ng-deep {
                font-size: 0px;
                display: block;
                position: relative;
                overflow: hidden;

                > img {
                    position: relative;
                    width: 100%;
                }
            }
        `
    ]
})
export class DfImageWrapperComponent {}
